const m14Section = {
  id: 'm14',
  name: '2027ScoresheetM14Sub1Label',
  fields: [
      {
          scoring: '2027ScoresheetM14Sub2Label',
          id: 'm14_scoring_1',
          options: [
            {
              description: '0',
              value: 0
            },
            {
              description: '1',
              value: 1
            },
            {
              description: '2',
              value: 2
            },
            {
              description: '3',
              value: 3
            },
            {
              description: '4',
              value: 4
            }
        ]
      },
      {
        scoring: '2027ScoresheetM14Sub3Label',
        id: 'm14_scoring_2',
        options: [
          {
            description: '0',
            value: 0
          },
          {
            description: '1',
            value: 1
          },
          {
            description: '2',
            value: 2
          },
          {
            description: '3',
            value: 3
          },
          {
            description: '4',
            value: 4
          }
      ]
    }
  ]
}

export default m14Section;

